import { useEffect, useState } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { apiService } from '../functions/api-service';
import { Alert, HandleChange, OptionSelects } from '../functions/utils';
import {ChangeEvent, Department,} from '../type';

type Props = {
  show: boolean;
  data: Department | null;
  handleClose: () => void;
  saved: () => void;
};

export default function ModalDept ( { show, data, handleClose, saved }: Props ) {
  let IsNew = true;
  const [dataForm, setDataForm] = useState<Department | null>( null );
  const handleChange = (e: ChangeEvent) => HandleChange(setDataForm, e);

  const handleSave = async () => {
    console.log( 'dataForm', dataForm )
    if(dataForm){
      const res = await apiService.saveDept( dataForm );
      if ( res.success === true ) {
        saved();
        handleClose();
      }
      Alert(res.success, res.message);
    }    
  }

  useEffect(() => {
    if ( show ) {
      setDataForm( data );
      console.log( 'data', data );
      IsNew = !data?.code;
    } else {
      setDataForm( null );
    }
  }, [show]);

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        // size={"lg"}
      >
        <Modal.Header closeButton>
          <Modal.Title>{!dataForm?.code ? `เพิ่มรายการ` : `แก้ไข ${dataForm?.name}`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form className={"row row-cols"} onSubmit={( e ) => {
            e.preventDefault();
            handleSave().then();
          }}>
            <Form.Group className="mb-3" controlId="name">
              <Form.Label>รหัส</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="ระบุรหัส"
                onChange={handleChange}
                name={"code"}
                value={dataForm?.code}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="name">
              <Form.Label>ชื่อแผนก</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="ระบุชื่อแผนก"
                onChange={handleChange}
                name={"name"}
                value={dataForm?.name}
              />
            </Form.Group>
            
            <div className="w-100 text-end">
              <Button variant="secondary" size="lg" onClick={handleClose}>
                ปิด
              </Button>{" "}
              <Button variant="primary" type="submit" size="lg">
                บันทึก
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>    
    </>
  );
}
